import { render, staticRenderFns } from "./ExitCard.vue?vue&type=template&id=4f8b4baa&scoped=true"
import script from "./ExitCard.vue?vue&type=script&lang=js"
export * from "./ExitCard.vue?vue&type=script&lang=js"
import style0 from "./ExitCard.vue?vue&type=style&index=0&id=4f8b4baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b4baa",
  null
  
)

export default component.exports